import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCustomerProfile } from '../../../api/services/customerService';
import { addSubscriber } from '../../../api/services/mailchimpService';

// Email icon component
const EmailIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z' />
    <polyline points='22,6 12,13 2,6' />
  </svg>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5%;
  margin-top: 20px;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const BlueBanner = styled.div`
  background-color: #2b388f;
  width: 90%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 200px;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    gap: 1.5rem;
    padding: 1.5rem 1rem;
    text-align: center;
  }

  @media (max-width: 480px) {
    padding: 1rem;
    gap: 1rem;
  }
`;

const SubscribeText = styled.h3`
  color: white;
  font-size: 1.1rem;
  font-weight: 500;
  margin: 0;
  white-space: nowrap;

  @media (max-width: 768px) {
    white-space: normal;
    font-size: 1rem;
  }
`;

const EmailForm = styled.form`
  display: flex;
  align-items: center;
  border: 1px solid white;
  border-radius: 4px;
`;

const EmailInput = styled.input`
  padding: 12px 16px;
  border: none;
  border-radius: 4px;
  font-size: 0.9rem;
  min-width: 250px;
  outline: none;

  &::placeholder {
    color: #999;
  }

  @media (max-width: 768px) {
    min-width: 200px;
    width: 100%;
  }

  @media (max-width: 480px) {
    min-width: 180px;
    padding: 10px 12px;
  }
`;

const SubscribeButton = styled.button`
  background-color: #2b388f;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #1a237e;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

const EmailSubscribeView = () => {
  const userInfo = useSelector((state) => state.userInfo);
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [customerProfile, setCustomerProfile] = useState(null);

  useEffect(() => {
    if (localStorage.getItem('token') && userInfo.idCustomer) {
      getUserProfileData();
    }
  }, [userInfo.idCustomer]);

  const getUserProfileData = async () => {
    try {
      const result = await getCustomerProfile(userInfo.idCustomer);
      setCustomerProfile(result.data);
    } catch (error) {
      if (error.response?.status !== 401 && error.response?.status !== 403) {
        console.error('Error calling getUserProfile:', error);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      return;
    }

    setIsSubmitting(true);

    try {
      // Get first and last name from customer profile
      const firstName = customerProfile?.firstname || '';
      const lastName = customerProfile?.lastname || '';

      await addSubscriber(email, firstName, lastName, ['Website Signup']);

      // Clear the email input after successful subscription
      setEmail('');
      alert('Thank you for subscribing!');
    } catch (error) {
      alert('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container>
      <BlueBanner>
        <SubscribeText>
          Join our email list for product updates and news
        </SubscribeText>
        <EmailForm onSubmit={handleSubmit}>
          <EmailInput
            type='email'
            placeholder='Enter your email here...'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isSubmitting}
          />
          <SubscribeButton type='submit' disabled={isSubmitting}>
            <EmailIcon />
          </SubscribeButton>
        </EmailForm>
      </BlueBanner>
    </Container>
  );
};

export default EmailSubscribeView;
